// extracted by mini-css-extract-plugin
export default {"task":"TaskList_task__f6rDX","details":"TaskList_details__+KGfS","actions":"TaskList_actions__AGARV"};